<template>
  <q-card flat bordered class="q-pa-md q-pa-sm-xl more-rounded-borders">
    <slot></slot>
  </q-card>
</template>

<script>
export default {
  name: "ComparePowerCard"
}
</script>

<style scoped>

</style>
